import { useEffect } from "react";
import * as React from "react";
import { useTheme } from "styled-components";

import { useAuth } from "@hooks/useAuth";

const VersionReporter = () => {
  const theme = useTheme();
  const { user, isUserAdmin, isUserLoggedIn } = useAuth();

  const getConsoleBreakStyle = () => {
    return `font-weight: bold; color: ${theme.palette.blue600}`;
  };
  const logCommitInfo = () => {
    console.log(`COMMIT HASH: ${process.env.COMMIT_HASH}`);
    console.log(
      `COMMIT URL: https://github.com/batmaid/frontend/commit/${process.env.COMMIT_HASH}`,
    );
  };
  const logVersion = () => {
    console.log(`VERSION: ${process.env.VERSION}`);
  };

  const logUserInfo = () => {
    if (user) {
      console.table ? console.table(user.toJS()) : console.log(user.toJS);
    }
  };

  const logAdmin = () => {
    console.groupCollapsed(
      "%cBatmaid Front-end Application Details",
      getConsoleBreakStyle(),
    );
    logVersion();
    logCommitInfo();
    console.groupCollapsed("%cImpersonating", getConsoleBreakStyle());
    logUserInfo();
    console.groupEnd();
    console.groupEnd();
  };

  useEffect(() => {
    if (isUserLoggedIn && isUserAdmin) {
      logAdmin();
    }
  }, [isUserLoggedIn, isUserAdmin]);

  return null;
};

export { VersionReporter };
